export default {
    statisticsAll: "/gateway/huilian/statistics/statisticsAll",
    statisticsDeliveryCar: "/gateway/huilian/statistics/statisticsDeliveryCar",
    querySelectBdDictionaryList:
        "/gateway/manageBedrock/bdDictionarycs/selectBdDictionaryList",
};



// WEBPACK FOOTER //
// ./src/dataScreen/index/api.js